import type { RxJsonSchema } from 'rxdb';
import type { PmCheckList } from './pmCheckList.types';

export const pmCheckListSchema: RxJsonSchema<PmCheckList> = {
  type: 'object',
  version: 1,
  description: 'describes pm check list',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    assetCategoryInspectionTypeCheckListId: { type: ['number', 'null'] },
    assetCategoryId: { type: ['number', 'null'] },
    inspectionTypeName: { type: ['string', 'null'] },
    inspectionTypeId: { type: ['number', 'null'] },
    stepNo: { type: ['number', 'null'] },
    stepName: { type: ['string', 'null'] },
    stepDetails: { type: ['string', 'null'] },
    parentChecklist: { type: ['number', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    children: {
      type: ['array', 'null'],
      items: {
        type: ['object', 'null'],
        properties: {
          id: { type: 'string' },
          assetCategoryInspectionTypeCheckListId: { type: ['number', 'null'] },
          assetCategoryId: { type: ['number', 'null'] },
          inspectionTypeName: { type: ['string', 'null'] },
          inspectionTypeId: { type: ['number', 'null'] },
          stepNo: { type: ['number', 'null'] },
          stepName: { type: ['string', 'null'] },
          stepDetails: { type: ['string', 'null'] },
          parentChecklist: { type: ['number', 'null'] },
          dateCreated: { type: ['string', 'null'] },
          dateModified: { type: ['string', 'null'] },
          site: { type: ['number', 'null'] },
          discipline: { type: ['number', 'null'] },
          isActive: { type: ['boolean', 'null'] },
        },
      },
    },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
  },
};
